/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { AngularFireModule } from '@angular/fire';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './@core/core.module';
import { environment } from '../environments/environment';
import {
  NbMenuModule,
  NbSidebarService,
  NbToastrModule,
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';

import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { ThemeModule } from './@theme/theme.module';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NbDatepickerModule, NbSelectModule } from '@nebular/theme';
import { LoginModule } from './pages/login/login.module';

import { AppComponent } from './app.component';

import { FirebaseService } from './services/firebase.service';
import { AuthGuardService } from './services/auth-guard.service';
import { DeauthGuardService } from './services/deauth-guard.service';
import { LoginService } from './services/login.service';
import { GWOService } from './services/gwo.service';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    LoginModule,
    AngularFireAuthModule,
    AngularFireModule.initializeApp(environment.firebase),
    NbDatepickerModule.forRoot(),
    NbSelectModule,
    NgbModule,
    NbToastrModule.forRoot(),
    NbMenuModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    NbEvaIconsModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    FirebaseService,
    AuthGuardService,
    DeauthGuardService,
    NbSidebarService,
    LoginService,
    GWOService,
    { provide: APP_BASE_HREF, useValue: '/' },
  ],
})
export class AppModule {}
